import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RouterHelper } from '../../global/helpers/router_helper';
import { StudentValueModel } from './../../global/components/student_value/model/student_value_model';
import { TermPlanPreviewQuery } from './../../preferences/components/preview_plan/queries/preview_term_plan_query';

export type PreventAccessToAdvisorAutoGeneratedPlanCommand = (
  terms: TermPlanPreviewQuery['result']['terms']
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'preventAccessToAdvisorAutoGeneratedPlanCommand',
    (
      defineCommandORM: IDefineCommand,
      routerHelper: RouterHelper,
      completedAutoGeneratedPreviewPlanShowingCommand: ICommand,
      ngStudentValueModel: StudentValueModel,
      ngPreviewTermPlanConstant: ng.IServiceProvider
    ) => {
      return defineCommandORM(
        'preventAccessToAdvisorAutoGeneratedPlanCommand',
        (deferred, terms: TermPlanPreviewQuery['result']['terms']) => {
          if (!_4.isEmpty(terms)) {
            return deferred.resolve();
          }
          return completedAutoGeneratedPreviewPlanShowingCommand().then(() => {
            const currentStudentValue = {};
            ngStudentValueModel
              .keys()
              .forEach((key: string) => (currentStudentValue[key] = ngStudentValueModel.getValueByKey(key)));
            currentStudentValue[ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']] = 'True';
            ngStudentValueModel.update(currentStudentValue);
            return routerHelper.navigateFromRouter(deferred, 'ap-advisor.plan');
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/re_route_strategies/prevent_access_to_advisor_auto_generated_plan_command.ts